class VideoGrid extends HTMLElement {
  constructor() {
    super();
    this.modal = this.querySelector('.js-modal');
    this.modalVideos = this.modal.querySelectorAll('.js-modal-video');
    this.listeners();
  }

  listeners() {
    this.addEventListener('click', this.handleClick.bind(this));
    this.modal.addEventListener('click', this.closeModal.bind(this));
  }

  handleClick(event) {
    const trigger = event.target.closest('.js-modal-trigger');
    if (!trigger) return;
    const activeVideo = this.modal.querySelector(`#${trigger.dataset.modalVideo}`);
    this.modalVideos.forEach(video => {
      const iframe = video.querySelector('iframe');
      if (iframe) {
        this.pauseVideo(iframe);
      }
      video.classList.toggle('hidden', video !== activeVideo);
    });

    const activeIframe = activeVideo.querySelector('iframe');
    if (activeIframe) {
      this.playVideo(activeIframe);
    }

    this.modal.classList.add('active');
  }

  closeModal(event) {
    if (!event.target.closest('.js-modal-video')) {
      this.modal.classList.remove('active');
      this.modalVideos.forEach(video => {
        const iframe = video.querySelector('iframe');
        if (iframe) {
          this.pauseVideo(iframe);
        }
      });
    }
  }

  playVideo(iframe) {
    const src = iframe.src;
    if (src.includes('youtube')) {
      iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    } else if (src.includes('vimeo')) {
      iframe.contentWindow.postMessage('{"method":"play"}', '*');
    }
  }

  pauseVideo(iframe) {
    const src = iframe.src;
    if (src.includes('youtube')) {
      iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    } else if (src.includes('vimeo')) {
      iframe.contentWindow.postMessage('{"method":"pause"}', '*');
    }
  }
}

window.customElements.define('video-grid', VideoGrid);